import { MutationTree } from "vuex";
import { CubeStateInterface } from "./state";
import MaObjects from "src/modules/ma/classes/ma_objects";

const mutation: MutationTree<CubeStateInterface> = {
  setStateByKey(state: any, { key, value }) {
    state[key] = value;
  },

  deleteReport(state: CubeStateInterface, key) {
    const index = state.reports.findIndex((x) => x.key == key);
    if (index != -1) {
      state.reports.splice(index, 1);
    }
  },

  putReportFromMaObj(state: CubeStateInterface, reportObj) {
    const key = MaObjects.obj2str(reportObj);
    const index = state.reports.findIndex((x) => x.key == key);
    const report = {
      key,
      title: reportObj.name,
      chartType: state.chartTypes.find(
        (y) => y.ref == MaObjects.ref2str(reportObj.items.chart_type)
      ),
      cubes: reportObj.items.cubes ? JSON.parse(reportObj.items.cubes) : [],
      cubejsQuery: reportObj.items.cubejs_query
        ? JSON.parse(reportObj.items.cubejs_query)
        : {},
      subscribe: reportObj.items.subscribe,
      export_only: reportObj.items.export_only,
    };
    if (index != -1) {
      state.reports[index] = report;
    } else {
      state.reports.push(report);
    }
  },

  addReportToDashboard(state: CubeStateInterface, { reportKey, dashboardKey }) {
    const i = state.dashboards.findIndex((x) => x.key == dashboardKey);
    const k = state.dashboards[i].reports_layout.findIndex(
      (x: any) => x.report == reportKey
    );
    if (k == -1) {
      const y = Math.max(
        ...state.dashboards[i].reports_layout.map((r: any) => r.y)
      );
      const h = Math.max(
        ...state.dashboards[i].reports_layout
          .filter((r: any) => r.y == y)
          .map((r: any) => r.h)
      );
      state.dashboards[i].reports_layout.push({
        x: 0,
        y: y + h == -Infinity ? 0 : y + h,
        w: 12,
        h: 10,
        report: reportKey,
      });
    }
  },

  deleteReportFromDashboard(
    state: CubeStateInterface,
    { reportKey, dashboardKey }
  ) {
    const i = state.dashboards.findIndex((x) => x.key == dashboardKey);
    const k = state.dashboards[i].reports_layout.findIndex(
      (x: any) => x.report == reportKey
    );
    if (k != -1) {
      state.dashboards[i].reports_layout.splice(k, 1);
    }
  },

  saveDashboardLayout(
    state: CubeStateInterface,
    { dashboard_key, reports_layout }
  ) {
    const i = state.dashboards.findIndex((x) => x.key == dashboard_key);
    if (i != -1) {
      state.dashboards[i].reports_layout = reports_layout;
    }
  },
};

export default mutation;
